import dynamic from 'next/dynamic';

const PromoLandingPage = dynamic(() => import('../js/pages/PromoLandingPage'), {ssr: false});

export default PromoLandingPage;
